import { render, staticRenderFns } from "./payInfo.vue?vue&type=template&id=2907dae6&scoped=true&"
import script from "./payInfo.vue?vue&type=script&lang=js&"
export * from "./payInfo.vue?vue&type=script&lang=js&"
import style0 from "./payInfo.vue?vue&type=style&index=0&id=2907dae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2907dae6",
  null
  
)

export default component.exports